import React from 'react';
import PropTypes from 'prop-types';
import RequiredAsterisk from '../../RequiredAsterisk';
export default function DatabaseFieldCell(props) {
  var value = props.value,
      required = props.row.required;
  return React.createElement("span", null, React.createElement(RequiredAsterisk, {
    required: !!required
  }), value);
}
DatabaseFieldCell.propTypes = {
  value: PropTypes.string.isRequired,
  row: PropTypes.object.isRequired
};